// This is the list of the uuids of all published, displayable, Major-type
// entities as of 5/15/26.
export const NICHE_MAJOR_UUIDS = [
	'916999fb-f354-475a-a628-f1b18df5c3da',
	'0227871c-2109-4656-953b-5e3803f7ccf6',
	'e6ec1a62-e479-42cf-8c6c-632dea5fb2a2',
	'1ac63bc3-a986-43f2-8586-09530da5dbbe',
	'920aafb4-23dd-43d4-b820-06f59cf99ac0',
	'7174a7d8-9a94-4a23-8f7b-0549f6cec62d',
	'5ad9f9c6-5062-4b03-9c2a-faec7faeb6e8',
	'1f55bad6-f1d4-454f-a982-52790c1926e0',
	'0e671c84-02d2-4f4a-a29c-254ec49eb643',
	'ba8a1c41-d573-44fc-a0d8-eb64f6141976',
	'597312c8-4bba-463d-8ac7-0aca1a815563',
	'd2077903-4731-47dd-9485-f4a9c74dd719',
	'06742452-c51a-469e-a01d-4b93806e83d6',
	'9b53e7f6-8aaa-4769-9d50-752484470ca4',
	'a8c3d3de-cdec-4630-b00d-a69dca99c15e',
	'b43275fa-3ac0-455c-9a78-8efc8fe8a217',
	'7130c27f-4694-4c99-968d-c72ae9b974de',
	'f7bcbbfa-e2c5-4dba-96b4-33aae298ff6a',
	'ba7e7cb1-6735-4dd9-9330-877d94335368',
	'60740d84-d6a3-43f9-915a-7f9d2d73cef2',
	'ded0aa2f-0889-4455-80a1-e2836331b8a5',
	'8059b93b-7c23-40cb-a1b4-e01cc87bd8e4',
	'87933a31-6324-47be-b916-c47b050a36ca',
	'7788af4f-f1aa-48c6-a87f-d2b49d073510',
	'6df58ce8-67c8-439c-b0b7-6a0dc8c1c92e',
	'0c8bf56b-a051-484f-bedc-62f18d1092c1',
	'a2a7fcc6-fad9-4a09-9af2-26e3bf4caef7',
	'1f0b900a-a0ea-46ed-8529-681d6257b073',
	'32dbcf8c-09ce-44eb-af16-8aedf21b31b8',
	'0816cccc-ba55-42cc-abeb-1586ea9c1a7e',
	'6b0bdaae-5792-40b0-83f1-ee50b60ad29b',
	'fb3057ad-56e2-47b7-ace7-ef27411a9c7f',
	'a838d37f-330a-426e-91e6-bff16633f9b0',
	'e66e5a1f-b21d-4bce-977c-c116f55c06bc',
	'e8b44d95-d7b2-4988-866d-66eb6ffab79a',
	'b4a3209e-c8d2-479d-b676-98d287933125',
	'ed78f7b3-75f1-481a-a4cc-616ccedcfa29',
	'84d30978-f7f5-4179-9384-7945cd7539ac',
	'1a4ad86e-29d7-401c-bc62-14bb8ace2b28',
	'3138716a-088e-47ad-8a73-0e6b11801746',
	'09274cd7-3972-43ed-ad74-bee42a8add7d',
	'8fcb2fd9-e482-4a32-b7a7-d52329a66e22',
	'cb4720d0-4ea1-4616-b1c9-ce7474292814',
	'8d55565c-2214-445d-97bf-48121092e45c',
	'8c23651c-0884-40a9-a1c0-2ebc998983d6',
	'0a5a8982-977b-4c0c-bfde-cffb7459e3c2',
	'476032a0-67bf-496a-85a9-2bdb1072ac6a',
	'3d1e7f6c-77f1-419e-af82-ced1aac4b2d3',
	'42f27fe1-8a32-4ff0-9ea4-12c59a99c1c4',
	'f4036f78-a323-4367-b6b1-64d8743317b0',
	'a62049ca-60ca-4646-82be-ad62d3525599',
	'a4135b70-583e-4f86-83b0-7a616641144d',
	'2165b959-315c-428c-b064-b682bcab1d10',
	'e1221e5e-690a-474e-aac7-461fb6387a6b',
	'a7a972b7-9cf0-4ee5-8309-ebc50a157bf3',
	'1dab5c87-7a62-4b7e-a760-a9085745adfb',
	'e1a13a70-142e-4463-a1e6-861fb0f769e4',
	'e2969841-e4a0-4bc2-bc78-3f27b98e6478',
	'bde0072a-f100-44a4-a0e6-c07e441c3ae7',
	'd42e9a04-4cdb-4044-8521-de7518886bb0',
	'2285d89a-c02c-46cc-a24e-ae9208269067',
	'9a9e659b-c2f5-4ee6-a10f-9f74203e4a1d',
	'473f7c63-14de-4e7c-8e0d-7f6a7d2a170f',
	'14b6a0a6-1ee5-4569-9f58-23970db78a80',
	'87cf1a1f-658b-4628-a7e8-4cb03d113228',
	'8547196c-515a-4500-9361-e53fdb8d031d',
	'41d94610-0b59-4be9-8ae8-a576152bc400',
	'6a3c8d8b-a781-4d54-aab1-392b33978a85',
	'3ab6826c-564e-4009-a007-285ebf108407',
	'fc45553d-a234-4731-88df-72869775cfa2',
	'deb20654-ba4e-488b-bfac-3f1292b09133',
	'0e9e7c8a-5d60-462f-9c65-67ef5215332c',
	'd1550c9e-2541-43dc-b13a-aa3a135db7d0',
	'657348f8-5952-4567-baf9-11aa651bacd5',
	'721731e4-8b75-4c21-bb6f-59040a6ee7a3',
	'5f33e5bf-7808-43c6-844b-d95a614b36a9',
	'9aa182e4-0b5e-4168-8059-e1a1b79ad2e6',
	'ddd08f7d-9b48-4aa1-bbf5-e1ffe9a12fb3',
	'c79b06b6-579d-4c31-bde6-76de7ceb94e3',
	'3cc9e13f-df7c-4050-8b6f-fbc4785bba71',
	'72343104-51ad-4a74-84e0-17a98decce38',
	'270a8e10-0b4d-4ddf-bfaa-9db0f8e80539',
	'01db8245-561d-41b0-82fd-4bd1ec1e4cec',
	'6d21f155-32f6-4a77-bfa8-2b1a0854aaea',
	'be4bf51f-59d3-45ad-8156-0291eb2bf0d9',
	'bc1f17b9-4656-4350-9ec5-71de3be2d880',
	'da3311f2-3ea3-4a15-bd20-772f4a63de28',
	'209ebc9d-1dc0-4ac0-ba9c-202f586a8985',
	'a84d7d0e-c0bf-4e9f-9d37-43f5369748fe',
	'df3201a9-cf55-494b-9547-ab72d317e9eb',
	'3f46500a-a659-4add-bef3-c52f9d95d79e',
	'7341e55b-57e9-4eea-a7ad-09191c418bf3',
	'38715d61-91e5-455f-aa2f-9b1eb38dd0ef',
	'8f80349e-a518-42cd-a04a-d4450447ea39',
	'71e001a9-2a26-465e-a0bc-944a5d7b030a',
	'0e437e9e-655c-4221-8bf4-7290a40533ef',
	'ce3086fe-74ff-4dee-b0c7-0df5747dad81',
	'c07b132b-b7b3-4aa6-a0d1-9f0a8854e149',
	'75fcd304-1d3d-4c76-9aec-113b8ac26154',
	'3d05f57e-e3a2-4cc3-b2a4-fba163397dcf',
	'f0c7cd66-5fe2-470a-ad2d-7ef5ad8db08b',
	'7bbcc8d8-fe26-4927-952f-8711a64996c2',
	'dfbe8e2a-007c-4e66-9314-59c881a70bf6',
	'9e5a3d3d-f13f-4f42-a2ee-7f692bfd154d',
	'2cc54340-28b9-4006-89ba-eb62b42b5b2f',
	'f118ea39-59a6-49c3-80b5-eacdd064cfcd',
	'387139de-10f2-4e32-a285-18211cb5bd3b',
	'9e4818c0-ab53-448e-8f6e-5a09a97292f0',
	'96020efe-e10b-4cda-97ba-af48ba38cc72',
	'8f05e73a-5f89-4718-b739-c55d71bd5c17',
	'6063e978-1648-4c96-9519-a84b16345f66',
	'9bd93fa2-0ca6-419d-9002-8d0eb62c49c0',
	'69f6dacb-cb6b-4775-ba5f-0ece9827fbe8',
	'e0a2989f-69e1-4578-85ac-253f56048387',
	'aa11fecc-0d5f-4553-aacf-dd1b3276eeae',
	'83e34df3-1daa-478e-a6b9-34e37a6254eb',
	'acc174fe-fb6e-4bb6-b41c-5324a7f04fd1',
	'f49c2aca-980a-4f92-ad98-3f867d45035a',
	'45c459aa-35d9-4138-9a82-44218b8c66ea',
	'6f3042b4-ebdb-464d-bf3e-0b88714f186b',
	'87d15ada-9afb-4d37-ab1d-39dea6c0d74f',
	'47a06d9d-63b2-495e-9020-9f05c8ab4739',
	'51a53a54-0ab0-4b0e-ae21-cf972c5a6a6e',
	'e99a5c40-d22f-4109-a105-732485be2b47',
	'f2f2ede4-1b88-4a19-b8ff-572735198d6b',
	'0a10706a-3c1d-4943-a32e-0bbbc9aa374a',
	'4a3b07dc-3c0a-4c2b-ac77-3a4d6e0efc93',
	'9ead63e1-306a-472f-a7e0-34a944c47b55',
	'e8a847fa-7504-4a07-8a50-21040f64ea9c',
	'cc1507ef-faed-413a-b683-810782c3eff1',
	'1f4bf9d6-6b5a-400a-9d2f-e7f72362de20',
	'5a10f4d7-1243-4f4a-b269-532f69820da0',
	'1d75713b-80ad-48ae-826e-98b9a9a696ef',
	'11984c44-d637-4a53-af03-af8feea2a75c',
	'93647725-4514-4fbd-aa24-7f6fc78a6efc',
	'41fc4fb8-3292-4da4-93bf-e836a281f6fa',
	'69461991-27d3-49d3-8ccb-c845cbfda8ff',
	'f2ef6827-fda4-433b-bf7e-7fd8c35d8f23',
	'054c3e8e-8bd9-458b-8f2c-a23df90923e3',
	'03ffb2fc-824e-4876-879f-4269d50297e0',
	'f4cc076d-a02f-49cf-a9c7-91e24de3e265',
	'4f7cad70-4dc9-499d-b28d-006f226bd1e4',
	'485d8101-c262-4610-b34a-0c61f2a3a29b',
	'549e5c25-b031-422d-9295-fd612198fe30',
	'ab3c6758-dac1-420d-9577-3a2996c15857',
	'416f1329-9e0d-4752-88dd-ffdc38ba7236',
	'd4405b51-7804-4b32-8deb-f5ae561ab86d',
	'9ed70271-39cf-4b26-864b-ce94c8b69f5b',
	'fbab1e6e-a074-4920-89c8-8261c796731b',
	'53275757-d08b-48f3-96e7-849c8c0477b6',
	'f6dbcd70-a346-4789-956d-06b1bff43805',
	'402ade72-be1d-419e-b6fd-ed9f1cff6a69',
	'dbe75ccd-8e37-4a05-a0e5-9163c2cb5c1f',
	'6e995ad5-47bd-4f44-9609-8e68898bc52b',
	'367ecf21-624c-4081-a2b1-dc7b409fb5c7',
	'875d8b20-b4db-485d-898e-3ca41212885b',
	'1f2a5f41-29ac-4d00-ba9f-4a7d8939fbe9',
	'e0434fa5-793e-4d6d-b84f-ff431f96b590',
	'82e363f1-309b-4b69-91d1-4197504f06f9',
	'fcd35f8f-a771-47ed-9e1f-7db1498b8efe',
	'582c611c-4bad-4efc-931f-97de1469c607',
	'296d5363-9a59-4b99-8adc-a78aedf241d9',
	'257a92f2-158a-4861-9c38-b37418cdb0bc',
	'ba465258-9178-4bc5-8ddc-8f731c409141',
	'656ebf2e-2612-46f6-aaf0-6c62b77518ca',
	'daaaea68-4d26-46bd-81cd-0629b53634cc',
	'1b6ba1e4-2c6a-4a52-b65d-25b9b2f8fb01',
	'bdfb79ed-14a0-4ff9-a0b7-18b37b56009e',
	'b3c93b99-f065-4f57-b80f-a05dbfc7ca78',
	'fd8dd73b-ddd8-422d-9be2-8411b54914c4',
	'290560ad-7768-4861-a796-7613a8452ea9',
	'd8dd3feb-140b-47d3-bf38-0c3a6a0d3aaa',
	'8aeeb4bf-def1-4a3e-89a9-ac3f0a03c182',
	'46b8ffed-5377-4bf9-87fe-d47ab559ab94',
	'1eac5e0e-dd18-4d6e-a7a8-ad80063d9105',
	'f4c586f5-e49b-4aad-91b9-a4940a9700f3',
	'1fcf52df-7b56-4855-966d-a2e90f834651',
	'5434f2fa-1ae2-477c-ab5a-d7e8e5cab268',
	'957a38cc-4ed7-4648-90af-9ec7bcbf7195',
	'be9b4f38-a975-40a4-9270-4c5f9296dd11',
	'd7154d5b-47a0-4b42-bf4b-b876a59df8ee',
	'8fd20c39-0cf2-41a6-b2c1-1b51749adb2c',
	'6c881639-fa61-4a9a-bfe0-f361cb406831',
	'd17aadb5-70bb-4cf6-a656-8aeda2084302',
	'27ae198b-ace1-4da7-a6da-0f9a4447eb6d',
	'2533ee87-7707-4128-b6e8-bc889383c921',
	'9843f4fd-8aff-4fe6-b566-fd83aed5f33d',
	'7cdb157b-bfee-45eb-b0ce-efa534f0a742',
	'31645c34-3f98-4c1c-b0ca-e7916dc80a20',
	'bc7953b2-db7d-4f8e-9e26-095038d9f26c',
	'77c9f9f2-bd35-4fa3-8d00-228ce2ed3d7e',
	'670f7799-067f-4eae-bd5d-458820dc7b8e',
	'9df2f2fa-5cdc-4210-a1d2-0204a18efdce',
	'8ca0588d-cff8-4186-b3cd-b076b887d1cd',
	'0e55dec3-1f54-4fdb-a297-5b4db751a7e6',
	'ccab52a5-6468-4cd3-b648-de23eba4a4a4',
	'257b46f0-5eb4-4743-be2f-93d971bf19a0',
	'59be9c73-b164-43c9-a0ac-494cf80c777b',
	'd7d3101d-1427-43c7-abd4-602da12cee36',
	'396a55cd-226e-4468-a64c-edaab3677194',
	'c113fed4-fbea-44cf-b6e3-c04bf30978e6',
	'40cde177-85da-4cb7-b280-30a52f894314',
	'f83341ba-e8f4-4cc6-ac2f-0dd997008a6d',
	'1e656d5d-cb0b-4bdb-b3d7-75deab58904c',
	'e3516aa4-b08b-4b66-b17d-40e8f47f287b',
	'3803c48e-ce9d-4bf0-8737-3e3dce78f831',
	'b8a839f5-e31f-4704-ae87-4d2535bd9fdf',
	'2755f099-9a2b-4791-ae9d-290c690b7bb2',
	'8daa20bc-127d-4cc8-abf1-9d65f2237d6e',
	'03ad4841-eab1-458f-8aae-097873e4d662',
	'5cffac6a-efe3-47a3-86bb-4388e403f060',
	'eaccf929-45b9-4f72-8b5a-1a6b94bb6172',
	'ef1f870d-d714-4a90-b255-2277e8ecad25',
	'549e7f76-57de-4356-9165-909b2a04521c',
	'c506da71-338d-415d-9d55-7a15bc61339d',
	'46febc0a-cabc-40d7-9728-590ed4aadb10',
	'b8b13535-fdde-4190-8630-547ccd7be6ed',
	'3249802a-a991-4cb6-964e-6c228229026b',
	'c50957dd-4e37-4353-91ee-51ead3d57a50',
	'ca59cc16-8eae-46f0-a4f5-c78bcdacfd57',
	'6ef5bac7-eb1e-4fdd-a10a-63b308b1a74a',
	'46648bb7-b088-4578-8257-5fd565bb14c2',
	'172176ff-1ec6-4ae2-934b-fa7193e7d3da',
	'5fd8eed2-936a-4e1b-8777-d8d9aa2f3f2c',
	'c606b57d-5e58-444d-8743-e5793a6e2e7c',
	'54bc6296-e68e-4934-80b7-5d968f2d0f15',
	'04930486-0e23-48d0-acf0-b31693def3c9',
	'ceb11576-acf2-4cb8-974e-928298068dfd',
	'62c25e0d-3e02-49a2-a17a-21d39e7f8722',
	'89a662d4-f9ef-42ee-acac-ed3ab6247a3f',
	'13a78eb6-9a54-4f50-b552-318262b5ceeb',
	'8afe3eae-6858-4813-99c1-56695a8c98fc',
	'e555f8d8-9b27-4bbb-a8f2-8a1348ad6bab',
	'1ad88883-86c5-4a2e-b960-73554dc27d1b',
	'a07783a7-2e0a-492a-bb5e-e03a22c7495a',
	'39cf86a3-a8c5-4c20-a334-0b5956d33679',
	'0de07b55-05fa-4111-8c11-c625eacb7354',
	'0dcd12c3-61a8-49f6-a179-f013d046a4ac',
	'331d86dd-178b-449a-9ee0-387494873f7e',
	'c0a7feb6-7251-4856-a10d-394257a6f4ce',
	'c81e5e57-66b5-48d6-817e-ad63998e4954',
	'db3d55d2-a174-41cb-a433-8eeb25588def',
	'14f1182d-03ea-4015-982d-6ac7bb6a468a',
	'c321d257-749a-4378-b7e4-3d4438b8a281',
	'8a6c5f51-696c-4cd2-bde6-0577263d03d0',
	'dc8e22aa-f2df-48c3-adf7-385e6d0fe67e',
	'9ab1e032-e109-4083-bacf-aaa30d946fd4',
	'89210286-1d63-4f52-b6e1-17b9eb6b89d8',
	'8781c0c0-a6e1-4cc3-a132-b9475ef50250',
	'b43176d8-c47f-4359-abef-a3710eaade56',
	'1f02e7d3-2136-4420-bf1c-dd7a8863ff0a',
	'b1324fd4-25de-4cac-bd1f-79c7c25d7963',
	'2ab789a3-d18b-49e4-8e9e-74dd3ba69a8b',
	'2d53d003-b24b-4b7c-a60c-7b2898e48f3e',
	'3fda4ace-27b3-4afe-8284-046908b46d92',
	'7f5d1693-0018-42e2-adc9-e8b366c285b2',
	'1dbe3537-174f-4c50-aa79-c666a76334ba',
	'f5f07c8c-831f-4c7f-9b38-bac3537328e2',
	'25f89f16-1089-43da-82a5-cb7f5535fa25',
	'd03f5139-72d6-407e-9125-4efd4dda83e8',
	'b2f34530-60a2-4c04-81a9-ba12257ba635',
	'bdfadd70-506a-4484-9e50-979f1871fb6e',
	'5155a586-fad4-4467-9fa6-db395d54e55e',
	'52d64e20-eb5c-45df-ba17-304447392869',
	'5b6311c2-64a8-4234-b3ed-0c8c4a41cce3',
	'6e3de52f-0801-4de6-95da-b63ba78a1354',
	'909f8289-03e0-4628-9482-b62e0291638f',
	'38e67600-1708-41fc-9f1d-a140e8c14331',
	'235eecf5-67be-4ff3-9f07-63b74f9d7fa1',
	'9c19cbb6-2b85-4e72-8cee-0ef0cedccd14',
	'3dc67ef0-1972-4385-99fb-a93f06a81071',
	'3b43927e-cff8-4cfb-bfbb-9b1a473ba208',
	'4b384fa9-eed8-41f1-baf2-b9f427c51214',
	'f4ea1ee7-e6cd-4565-8044-2f9596a213af',
	'dcf5df9b-9696-4a7d-855e-a2b46492f661',
	'133cdd67-fb37-4c65-90b5-a9186f454aad',
	'd3d250df-bb92-4863-b8af-d66bcd3a8f9a',
	'aa56df21-052d-4bf6-808b-b095e197b166',
	'd4b816b6-42b0-42f1-ad28-25671d6e3c98',
	'9d7747e1-c527-47da-9fd5-fd8d4007413a',
	'c0b77605-3d7c-4cf0-829b-2e3419f949a8',
	'e09bc641-6ea0-410c-9b39-1a284b5c52ed',
	'b4db7719-8e35-4d18-8e48-37980026f016',
	'c2ce8862-0d98-4145-99d5-26a6ec88b50a',
	'6ba0327a-ca48-4323-868a-431f3ac74b92',
	'b04cd39f-9115-4489-9cce-3cfee870cd17',
	'412aa7ce-d37c-4926-bcf1-199681137da0',
	'65fad0bc-ae3d-4617-bb37-547868c360e4',
	'933b5e8a-9435-4bfc-8ff9-6b773c589739',
	'1ba679f1-1fde-4dc5-b8dd-83dd7d0326c7',
	'8bda4997-ed8b-495d-8ee0-504d6fc21918',
	'3671f238-1db1-49e5-8ef5-4ee09616f119',
	'5fb33231-c28b-4e74-ab5a-7c0989f6fcbc',
	'6d31d8de-1f62-4f3e-8eea-07bd8e4565fc',
	'd4d9e8f3-6bf0-4395-aacb-9e15f627854b',
	'6f45a618-8fb3-49c4-98ac-0c8536f0dce6',
	'e26b35f1-42f7-42b8-a25b-ab852a644df3',
	'a1f7391a-b071-4668-b528-7860ab34436b',
	'95e4cba1-aff3-4488-8faf-4e7cd5a03f70',
	'68f0dc64-d2dd-458c-967d-abd08c26c935',
	'2b649dac-8622-47b9-9221-0a0f4fb39e31',
	'3c5a8d96-9874-4961-8c3d-ab549fe73ea0',
	'9d5b34bd-7247-4fe2-94a4-1bb8e582bb47',
	'093e5f3f-8c87-44ef-8a30-926a02484873',
	'a6770d5f-f578-4368-9ec5-56eaed49ae45',
	'adee7d7d-cb6b-4f78-91b6-d5d399ff796d',
	'56719e21-c348-4d79-9e0b-bfcabd5ae2ee',
	'90ac26c8-9d35-47cf-b944-f252f1a87202',
	'337e70a1-f324-4d06-b558-984e5ac99714',
	'acc711f6-080d-4d47-b485-7814050dea9a',
	'55391138-9a18-4ac0-9da7-131afa382928',
	'6a57fef9-06a8-4117-b62b-8fff3d02bf98',
	'76356afc-94af-4829-9f01-d34b48d240a7',
	'352b3d76-8278-487c-9c05-3038bf3df355',
	'21c0ee9c-8545-47c6-880a-6d45ea6d01af',
	'0a918c77-8b97-4154-af60-765afd5d85fe',
	'd87701d0-c620-4ea6-b5f4-99ac5a6b594e',
	'1c8f4117-2670-472c-86f5-cb139dfb8698',
	'db90820e-2102-4113-ba4e-c21179c45b92',
	'882196d1-f0ec-4a33-aa48-f31a84d8e5b1',
	'64835c0e-22d1-404a-a50d-b4c4edde602a',
	'786d036c-98af-4729-b6fa-764427974cde',
	'8083c4e0-7e75-4322-b8d2-c4383e04ee4d',
	'43dda34d-d754-4b43-8087-f201a60196ff',
	'0e5c904e-faf2-45a8-bbd0-0b4017fefcf9',
	'c74c6685-e4ff-4319-a63b-5b0095f66e58',
	'9ff2c0e3-5c38-455f-8f0b-c77af0677c43',
	'02c7db0f-6fdb-4477-91dd-326a153da2e7',
	'51cd18c9-b18e-4e11-8f40-80d52630108b',
	'0851dd59-153c-4b42-8bd0-aed40b882161',
	'5a2c114d-44d4-499f-b660-6f0343122928',
	'bfad4f00-3edf-496d-9249-36320bec6fc3',
	'c92c637c-ea31-4d55-a814-0d76bededbd9',
	'7d3d59db-2994-4be2-9360-0a563e67e4b8',
	'b704637e-b5a9-4f0a-a687-266cf10c0334',
	'cc55739e-da8e-4763-b1f7-1bb5cc0fc124',
	'ccb54ea3-3a73-4a14-a49f-1dc6f29b378f',
	'2d355ed9-4cd5-441b-9f56-68797011ade1',
	'143fd637-be94-402b-8cd8-4796198bcbfc',
	'976a7308-6103-41f2-9210-349922d0be74',
	'1d2dd859-ffb1-49d2-b05b-3a93062130f6',
	'b94a9db5-298f-41fa-a155-82b3af3b5a8e',
	'5949e23f-22a0-4498-8a74-98ff01d38203',
	'049b572c-1881-49f8-8537-4e63572eaa51',
	'ba88111b-0fd3-4c1f-85a6-78e2ab42f0cb',
	'6de4d10c-22ab-45c8-940a-be3c61bb8595',
	'81f31a7e-553b-4540-9309-1bef2f01574e',
	'bff2e6af-6f71-4b9e-9737-f0cc8daf965a',
	'16d264d4-408c-4089-a2cf-0bb38583869a',
	'7d8d1c13-f415-4ae2-aef8-8905a0ce43c7',
	'4cf314ce-98b1-4ffb-8ba9-ccdcf5bfca8b',
	'91347f53-5918-4a60-aa84-27937ecc86ca',
	'1b8d9517-5184-4882-b261-1d264be2be3e',
	'71651198-113b-4b10-8ccd-4b0309e72529',
	'26ac5667-0c86-4038-bee8-982b28dda3b8',
	'8a5ba5e7-da12-48cf-a255-13393e6e0422',
	'f5cec120-548e-4bed-b8a8-bb1d1bc69d2a',
	'af75f777-c07f-4c33-90c5-e59ffa83244b',
	'75827e12-df54-44ff-b9b5-ebf15f5299f0',
	'e319653d-73a8-4f17-af77-95072d5ebaa4',
	'6039cfa8-1d3a-42f4-9741-d5eb6ea36bcd',
	'5c9eebb8-e0c2-4505-a7b6-11d08118f9c8',
	'c8b4a2e2-0b47-4a62-896e-95aec08632d6',
	'3d3bcf25-dab8-470e-b545-c75223088b5b',
	'ca361223-d30d-417a-8073-1f9438ab6cea',
	'3c626ab7-9aad-4bb3-829f-9bd440f7200f',
	'd9a88163-873c-49e5-8396-558f8cb02c31',
	'a99e4cbe-0762-462e-85bc-726d17240daa',
	'c0f0a3cc-88c2-4526-b71f-07ea13afe815',
	'5b312d6d-ec4e-48c2-942c-85d29f2cde14',
	'b3f83132-8f7b-4b7d-b600-e734690d1882',
	'23a0886b-cfa2-4f80-b973-8466f1612abb',
	'304620af-9534-402f-94d7-c68a205a7b7b',
	'69384ab2-04ff-46fc-8004-af2cafd2acb7',
	'b1059fdf-4df4-4402-ba2a-079ba0886e0f',
	'9051ddbe-0f9e-44b1-9236-e9caa89460c8',
	'331e2805-e03d-4e15-8054-fff7dc9cbf46',
	'50d32b94-1643-4928-9ff6-892581e92cd2',
	'54823891-ccc0-48b8-93f9-eee6863a3724',
	'08e47a24-be77-4a4f-bce1-c100285c78cc',
	'7b6553ed-f40e-4f5e-ab59-fb554e0996be',
	'9a814ed6-d390-4e7b-b8c5-8ebe3d7ad07f',
	'1ed7b196-418f-4af7-b1cc-42e4e89e5478',
	'64375beb-e029-4c23-8767-72dd06ba357e',
	'027f1d52-061e-4811-b999-a595c0e7d00e',
	'82a447ef-9a7c-4be6-9ec4-3d184a76da06',
	'55c395f8-dc61-4bf0-b356-1265210bbdec',
	'c8c494e9-d6f9-4f24-8424-7cf6d6655e69',
	'8c7a96c9-10ba-47c7-b477-104035ad1315',
	'b4836372-181d-47c1-ae07-d415a7d5df6e',
	'55ba66b1-e47b-44c1-adc5-341a2f02c656',
	'8241aff3-96d9-4c39-ad0a-ac0cf20bae79',
	'5ca50084-e4ec-4e7c-998c-ff298f11c255',
	'4293ee76-3b4f-4af9-ba30-575df068f489',
	'f882bbba-c84b-43c4-ae86-e88444cf8d56',
	'44adeafe-9b3d-4cc0-8170-12f6ada6d0e3',
	'6cfb2b77-e587-4f96-a42e-100e52124406',
	'defbcebc-30dc-4ef3-930f-9f197337b6cb',
	'515139c7-cf1a-458e-8e39-54758e8259ad',
	'8ed9c872-b34f-4ce1-aef6-5fc5fee9a5ad',
	'0e4b19bd-e783-433b-a388-0499f8183087',
	'b0689bc4-1d8f-4864-b14a-8c1fdb963ad0',
	'8cbd0064-5587-45da-bf89-1c81f999623f',
	'b9270038-779e-48e3-87c7-39b0291df3c4',
	'4b6b8bb1-1e69-478a-8d65-a00dc9db4ef2',
	'88f2e9d8-977a-44b4-9c84-6f9e386f84a9',
	'7696fe50-8cde-49fd-845e-8891ff8655e1',
	'ece4e0de-e7ba-4494-a13b-56dcaca60c6e',
	'f9ede9bb-5d5f-4b15-9cb2-5165afdcf8b5',
	'8e4153e7-b383-4f11-89b8-8cd945f323e7',
	'bd37536d-eef8-4f63-bdbf-7852ba71cf32',
	'3ab49a44-8e46-4687-9085-cc03c7afe909',
	'9be9f170-9c17-4351-8fe8-8ef5c3b63958',
	'449c1b11-82eb-4840-8497-d448122333cf',
	'34e9003f-3e58-4627-81b6-3cad6a80e84c',
	'7717dae9-5ed4-4654-9538-66b731d9e599',
	'046e0c1b-1682-409f-b7e5-271dac70759d',
	'56d29372-948d-4cac-b50d-1c605bd07eaa',
	'f193809c-49a2-4aae-a129-6f00542a93fc',
	'd71549ae-adf5-4306-958f-ecb5e8c0b4d9',
	'1be795d3-6170-472b-a6c1-da3f67f8e101',
	'8c7d8a6f-43f3-4290-8ce9-54de32eebae8',
	'f5fd680b-679a-4df5-9dbb-a0c43b1bba58',
	'34c6f70b-8a29-4c4d-a45b-92e3bd5ec1af',
	'3c2fb035-6ea1-49dc-825c-673c9856add2',
	'4e1b9a64-a825-4aae-a580-0a8b9f2efc3d',
	'02d0c0e9-50b2-4e63-80c5-d4ff4ea4c9bc',
	'e9b55717-da8e-40cd-9953-c7f2fdccd259',
	'9f5509c7-a58f-47d2-921e-cae01bbeaa37',
	'a2a135f7-6192-4371-9ef0-9f0d20b67aa8',
	'a734c5ec-703d-46d5-b573-9541976efb97',
	'fbde61eb-6754-490d-86a4-0fc0ade6a58f',
	'8384eec6-fc60-4e4f-b968-d2a664b85a7f',
	'd9269721-40a3-40c8-8de1-88ee94369c71',
	'581e9480-d764-4fa2-acfc-46948aec3d0c',
	'66b793c5-6de3-4b70-95c7-5db74d886c11',
	'8cde91b2-c1a3-465a-bb7f-f9c642aa25c0',
	'4d8ad317-d797-4236-bc00-deb9490b7eb2',
	'935efc12-cb16-4532-928b-1a7262624737',
];

// This is the list of the uuids mapped to their respective names of all
// published, displayable, Major-type entities as of 5/15/26.
export const NICHE_MAJOR_UUIDS_TO_LABELS: Record<string, string> = {
	'916999fb-f354-475a-a628-f1b18df5c3da': 'Accounting',
	'0227871c-2109-4656-953b-5e3803f7ccf6':
		'Accounting Technician and Bookkeeping',
	'e6ec1a62-e479-42cf-8c6c-632dea5fb2a2': 'Acting',
	'1ac63bc3-a986-43f2-8586-09530da5dbbe': 'Actuarial Science',
	'920aafb4-23dd-43d4-b820-06f59cf99ac0': 'Adult and Continuing Education',
	'7174a7d8-9a94-4a23-8f7b-0549f6cec62d':
		'Adult Development, Gerontology, and Aging',
	'5ad9f9c6-5062-4b03-9c2a-faec7faeb6e8': 'Advertising',
	'1f55bad6-f1d4-454f-a982-52790c1926e0': 'Aeronautics and Aviation Technology',
	'0e671c84-02d2-4f4a-a29c-254ec49eb643': 'Aerospace Engineering',
	'ba8a1c41-d573-44fc-a0d8-eb64f6141976': 'Aerospace Engineering Technician',
	'597312c8-4bba-463d-8ac7-0aca1a815563': 'African American Studies',
	'd2077903-4731-47dd-9485-f4a9c74dd719': 'African Studies',
	'06742452-c51a-469e-a01d-4b93806e83d6':
		'Agricultural and Food Products Processing',
	'9b53e7f6-8aaa-4769-9d50-752484470ca4': 'Agricultural Business',
	'a8c3d3de-cdec-4630-b00d-a69dca99c15e': 'Agricultural Engineering',
	'b43275fa-3ac0-455c-9a78-8efc8fe8a217':
		'Agricultural Mechanics and Machinery',
	'7130c27f-4694-4c99-968d-c72ae9b974de': 'Agricultural Production Operations',
	'f7bcbbfa-e2c5-4dba-96b4-33aae298ff6a': 'Agricultural Teacher Education',
	'ba7e7cb1-6735-4dd9-9330-877d94335368': 'Agriculture',
	'60740d84-d6a3-43f9-915a-7f9d2d73cef2': 'Aircraft Maintenance',
	'ded0aa2f-0889-4455-80a1-e2836331b8a5': 'Air Transportation',
	'8059b93b-7c23-40cb-a1b4-e01cc87bd8e4':
		'Alternative Medicine and Holistic Health',
	'87933a31-6324-47be-b916-c47b050a36ca': 'Animal Grooming',
	'7788af4f-f1aa-48c6-a87f-d2b49d073510': 'Animal Sciences and Husbandry',
	'6df58ce8-67c8-439c-b0b7-6a0dc8c1c92e': 'Animal Training',
	'0c8bf56b-a051-484f-bedc-62f18d1092c1':
		'Animation, Video Graphics and Special Effects',
	'a2a7fcc6-fad9-4a09-9af2-26e3bf4caef7': 'Anthropology',
	'1f0b900a-a0ea-46ed-8529-681d6257b073': 'Apparel and Textile Science',
	'32dbcf8c-09ce-44eb-af16-8aedf21b31b8': 'Aquaculture',
	'0816cccc-ba55-42cc-abeb-1586ea9c1a7e': 'Arabic Language and Literature',
	'6b0bdaae-5792-40b0-83f1-ee50b60ad29b': 'Archaeology',
	'fb3057ad-56e2-47b7-ace7-ef27411a9c7f': 'Architectural Engineering',
	'a838d37f-330a-426e-91e6-bff16633f9b0':
		'Architectural Engineering Technician',
	'e66e5a1f-b21d-4bce-977c-c116f55c06bc': 'Architecture',
	'e8b44d95-d7b2-4988-866d-66eb6ffab79a': 'Art History',
	'b4a3209e-c8d2-479d-b676-98d287933125': 'Artificial Intelligence',
	'ed78f7b3-75f1-481a-a4cc-616ccedcfa29': 'Arts',
	'84d30978-f7f5-4179-9384-7945cd7539ac':
		'Arts, Entertainment, and Media Management',
	'1a4ad86e-29d7-401c-bc62-14bb8ace2b28': 'Art Teacher Education',
	'3138716a-088e-47ad-8a73-0e6b11801746': 'Asian Studies',
	'09274cd7-3972-43ed-ad74-bee42a8add7d': 'Astronomy and Astrophysics',
	'8fcb2fd9-e482-4a32-b7a7-d52329a66e22': 'Athletic Training',
	'cb4720d0-4ea1-4616-b1c9-ce7474292814':
		'Atmospheric Sciences and Meteorology',
	'8d55565c-2214-445d-97bf-48121092e45c': 'Audiology',
	'8c23651c-0884-40a9-a1c0-2ebc998983d6': 'Automotive Engineering Technician',
	'0a5a8982-977b-4c0c-bfde-cffb7459e3c2': 'Automotive Mechanics',
	'476032a0-67bf-496a-85a9-2bdb1072ac6a': 'Aviation Management and Operations',
	'3d1e7f6c-77f1-419e-af82-ced1aac4b2d3': 'Baking and Pastry Arts',
	'42f27fe1-8a32-4ff0-9ea4-12c59a99c1c4': 'Banking and Finance',
	'f4036f78-a323-4367-b6b1-64d8743317b0': 'Barbering',
	'a62049ca-60ca-4646-82be-ad62d3525599': 'Behavioral Sciences',
	'a4135b70-583e-4f86-83b0-7a616641144d': 'Biblical Studies',
	'2165b959-315c-428c-b064-b682bcab1d10':
		'Bilingual and Multicultural Education',
	'e1221e5e-690a-474e-aac7-461fb6387a6b': 'Biochemistry and Molecular Biology',
	'a7a972b7-9cf0-4ee5-8309-ebc50a157bf3':
		'Bioengineering and Biomedical Engineering',
	'1dab5c87-7a62-4b7e-a760-a9085745adfb': 'Bioinformatics',
	'e1a13a70-142e-4463-a1e6-861fb0f769e4': 'Biology',
	'e2969841-e4a0-4bc2-bc78-3f27b98e6478': 'Biology Laboratory Technician',
	'bde0072a-f100-44a4-a0e6-c07e441c3ae7':
		'Biomedical Sciences and Molecular Medicine',
	'd42e9a04-4cdb-4044-8521-de7518886bb0': 'Biomedical Technician',
	'2285d89a-c02c-46cc-a24e-ae9208269067': 'Biotechnology',
	'9a9e659b-c2f5-4ee6-a10f-9f74203e4a1d': 'Botany and Plant Physiology',
	'473f7c63-14de-4e7c-8e0d-7f6a7d2a170f': 'Brewing Science',
	'14b6a0a6-1ee5-4569-9f58-23970db78a80': 'Broadcast Journalism',
	'87cf1a1f-658b-4628-a7e8-4cb03d113228': 'Business',
	'8547196c-515a-4500-9361-e53fdb8d031d': 'Business Analytics',
	'41d94610-0b59-4be9-8ae8-a576152bc400': 'Business Support Services',
	'6a3c8d8b-a781-4d54-aab1-392b33978a85': 'Business Teacher Education',
	'3ab6826c-564e-4009-a007-285ebf108407': 'Cardiovascular Technician',
	'fc45553d-a234-4731-88df-72869775cfa2': 'Carpentry',
	'deb20654-ba4e-488b-bfac-3f1292b09133': 'Cellular Biology',
	'0e9e7c8a-5d60-462f-9c65-67ef5215332c': 'Ceramics',
	'd1550c9e-2541-43dc-b13a-aa3a135db7d0': 'Chemical Engineering',
	'657348f8-5952-4567-baf9-11aa651bacd5': 'Chemistry',
	'721731e4-8b75-4c21-bb6f-59040a6ee7a3': 'Child Care Provider',
	'5f33e5bf-7808-43c6-844b-d95a614b36a9': 'Child Development',
	'9aa182e4-0b5e-4168-8059-e1a1b79ad2e6': 'Chinese Language and Literature',
	'ddd08f7d-9b48-4aa1-bbf5-e1ffe9a12fb3': 'Cinematography and Video Production',
	'c79b06b6-579d-4c31-bde6-76de7ceb94e3': 'Civil Engineering',
	'3cc9e13f-df7c-4050-8b6f-fbc4785bba71': 'Civil Engineering Technician',
	'72343104-51ad-4a74-84e0-17a98decce38': 'Clinical Psychology',
	'270a8e10-0b4d-4ddf-bfaa-9db0f8e80539': 'Cloud Computing',
	'01db8245-561d-41b0-82fd-4bd1ec1e4cec': 'Cognitive Science',
	'6d21f155-32f6-4a77-bfa8-2b1a0854aaea': 'Commercial and Advertising Art',
	'be4bf51f-59d3-45ad-8156-0291eb2bf0d9': 'Commercial Photography',
	'bc1f17b9-4656-4350-9ec5-71de3be2d880': 'Communication Disorders',
	'da3311f2-3ea3-4a15-bd20-772f4a63de28': 'Communications',
	'209ebc9d-1dc0-4ac0-ba9c-202f586a8985': 'Communications Technicians',
	'a84d7d0e-c0bf-4e9f-9d37-43f5369748fe':
		'Community Health Services and Counseling',
	'df3201a9-cf55-494b-9547-ab72d317e9eb': 'Community Organization and Advocacy',
	'3f46500a-a659-4add-bef3-c52f9d95d79e': 'Community Psychology',
	'7341e55b-57e9-4eea-a7ad-09191c418bf3':
		'Computational and Applied Mathematics',
	'38715d61-91e5-455f-aa2f-9b1eb38dd0ef': 'Computer and Information Sciences',
	'8f80349e-a518-42cd-a04a-d4450447ea39':
		'Computer and Information Systems Security',
	'71e001a9-2a26-465e-a0bc-944a5d7b030a': 'Computer Engineering Technician',
	'0e437e9e-655c-4221-8bf4-7290a40533ef': 'Computer Game Programming',
	'ce3086fe-74ff-4dee-b0c7-0df5747dad81': 'Computer Graphics',
	'c07b132b-b7b3-4aa6-a0d1-9f0a8854e149': 'Computer Hardware Engineering',
	'75fcd304-1d3d-4c76-9aec-113b8ac26154': 'Computer Installation and Repair',
	'3d05f57e-e3a2-4cc3-b2a4-fba163397dcf': 'Computer Programming',
	'f0c7cd66-5fe2-470a-ad2d-7ef5ad8db08b': 'Computer Science',
	'7bbcc8d8-fe26-4927-952f-8711a64996c2': 'Computer Software Engineering',
	'dfbe8e2a-007c-4e66-9314-59c881a70bf6': 'Computer Systems Analysis',
	'9e5a3d3d-f13f-4f42-a2ee-7f692bfd154d':
		'Computer Systems Networking and Telecommunications',
	'2cc54340-28b9-4006-89ba-eb62b42b5b2f': 'Computer Systems Technician',
	'f118ea39-59a6-49c3-80b5-eacdd064cfcd': 'Conducting',
	'387139de-10f2-4e32-a285-18211cb5bd3b':
		'Construction and Heavy Equipment Operation',
	'9e4818c0-ab53-448e-8f6e-5a09a97292f0': 'Construction Engineering',
	'96020efe-e10b-4cda-97ba-af48ba38cc72': 'Construction Engineering Technician',
	'8f05e73a-5f89-4718-b739-c55d71bd5c17': 'Construction Management',
	'6063e978-1648-4c96-9519-a84b16345f66': 'Corporate Communications',
	'9bd93fa2-0ca6-419d-9002-8d0eb62c49c0': 'Cosmetology',
	'69f6dacb-cb6b-4775-ba5f-0ece9827fbe8':
		'Cosmetology Instruction and Salon Management',
	'e0a2989f-69e1-4578-85ac-253f56048387': 'Counseling Psychology',
	'aa11fecc-0d5f-4553-aacf-dd1b3276eeae': 'Creative Writing',
	'83e34df3-1daa-478e-a6b9-34e37a6254eb': 'Criminal Justice and Corrections',
	'acc174fe-fb6e-4bb6-b41c-5324a7f04fd1':
		'Criminal Justice and Law Enforcement Administration',
	'f49c2aca-980a-4f92-ad98-3f867d45035a': 'Criminal Justice and Safety Studies',
	'45c459aa-35d9-4138-9a82-44218b8c66ea': 'Criminology',
	'6f3042b4-ebdb-464d-bf3e-0b88714f186b': 'Crop and Soil Sciences',
	'87d15ada-9afb-4d37-ab1d-39dea6c0d74f': 'Culinary Arts and Food Service',
	'47a06d9d-63b2-495e-9020-9f05c8ab4739':
		'Cyber/Computer Forensics and Counterterrorism',
	'51a53a54-0ab0-4b0e-ae21-cf972c5a6a6e': 'Dance',
	'e99a5c40-d22f-4109-a105-732485be2b47': 'Data Analytics, General',
	'f2f2ede4-1b88-4a19-b8ff-572735198d6b': 'Data Processing',
	'0a10706a-3c1d-4943-a32e-0bbbc9aa374a': 'Data Science',
	'4a3b07dc-3c0a-4c2b-ac77-3a4d6e0efc93': 'Dental Assisting',
	'9ead63e1-306a-472f-a7e0-34a944c47b55': 'Dental Hygiene',
	'e8a847fa-7504-4a07-8a50-21040f64ea9c': 'Design and Visual Communications',
	'cc1507ef-faed-413a-b683-810782c3eff1': 'Developmental and Child Psychology',
	'1f4bf9d6-6b5a-400a-9d2f-e7f72362de20': 'Diesel Mechanics',
	'5a10f4d7-1243-4f4a-b269-532f69820da0': 'Dietetics and Clinical Nutrition',
	'1d75713b-80ad-48ae-826e-98b9a9a696ef':
		'Digital Communication and Media/Multimedia',
	'11984c44-d637-4a53-af03-af8feea2a75c': 'Digital Marketing',
	'93647725-4514-4fbd-aa24-7f6fc78a6efc':
		'Divinity, Ministry, and Pre-Theology',
	'41fc4fb8-3292-4da4-93bf-e836a281f6fa': 'Drafting and Design (CAD/CADD)',
	'69461991-27d3-49d3-8ccb-c845cbfda8ff': 'Drama and Theatre Production',
	'f2ef6827-fda4-433b-bf7e-7fd8c35d8f23': 'Drawing',
	'054c3e8e-8bd9-458b-8f2c-a23df90923e3': 'Early Childhood Education',
	'03ffb2fc-824e-4876-879f-4269d50297e0':
		'East Asian Languages and Literatures',
	'f4cc076d-a02f-49cf-a9c7-91e24de3e265': 'Ecology and Evolutionary Biology',
	'4f7cad70-4dc9-499d-b28d-006f226bd1e4': 'E-Commerce',
	'485d8101-c262-4610-b34a-0c61f2a3a29b': 'Economics',
	'549e5c25-b031-422d-9295-fd612198fe30': 'Education',
	'ab3c6758-dac1-420d-9577-3a2996c15857': 'Educational Administration',
	'416f1329-9e0d-4752-88dd-ffdc38ba7236': 'Education Research and Evaluation',
	'd4405b51-7804-4b32-8deb-f5ae561ab86d': 'Electrical Engineering',
	'9ed70271-39cf-4b26-864b-ce94c8b69f5b': 'Electrical Engineering Technician',
	'fbab1e6e-a074-4920-89c8-8261c796731b': 'Electrician',
	'53275757-d08b-48f3-96e7-849c8c0477b6':
		'Electronics Equipment Installation and Repair',
	'f6dbcd70-a346-4789-956d-06b1bff43805': 'Elementary Education',
	'402ade72-be1d-419e-b6fd-ed9f1cff6a69': 'Emergency Care Attendant (EMT)',
	'dbe75ccd-8e37-4a05-a0e5-9163c2cb5c1f':
		'Emergency Medical Technician (EMT Paramedic)',
	'6e995ad5-47bd-4f44-9609-8e68898bc52b': 'Engineering',
	'367ecf21-624c-4081-a2b1-dc7b409fb5c7': 'Engineering Mechanics',
	'875d8b20-b4db-485d-898e-3ca41212885b': 'Engineering Physics',
	'1f2a5f41-29ac-4d00-ba9f-4a7d8939fbe9': 'Engineering Science',
	'e0434fa5-793e-4d6d-b84f-ff431f96b590': 'Engineering Technician',
	'82e363f1-309b-4b69-91d1-4197504f06f9': 'English',
	'fcd35f8f-a771-47ed-9e1f-7db1498b8efe':
		'English and Speech Teacher Education',
	'582c611c-4bad-4efc-931f-97de1469c607': 'Entrepreneurship',
	'296d5363-9a59-4b99-8adc-a78aedf241d9':
		'Environmental Architecture and Design',
	'257a92f2-158a-4861-9c38-b37418cdb0bc': 'Environmental Engineering',
	'ba465258-9178-4bc5-8ddc-8f731c409141':
		'Environmental Engineering Technician',
	'656ebf2e-2612-46f6-aaf0-6c62b77518ca': 'Environmental Health',
	'daaaea68-4d26-46bd-81cd-0629b53634cc': 'Environmental Science',
	'1b6ba1e4-2c6a-4a52-b65d-25b9b2f8fb01': 'Equine Studies',
	'bdfb79ed-14a0-4ff9-a0b7-18b37b56009e': 'Esthetician and Skin Care',
	'b3c93b99-f065-4f57-b80f-a05dbfc7ca78': 'European and Russian Studies',
	'fd8dd73b-ddd8-422d-9be2-8411b54914c4': 'Exercise Physiology',
	'290560ad-7768-4861-a796-7613a8452ea9': 'Family and Community Services',
	'd8dd3feb-140b-47d3-bf38-0c3a6a0d3aaa':
		'Family Practice and Pediatric Nursing',
	'8aeeb4bf-def1-4a3e-89a9-ac3f0a03c182':
		'Family Studies and Consumer Sciences',
	'46b8ffed-5377-4bf9-87fe-d47ab559ab94': 'Fashion and Apparel Design',
	'1eac5e0e-dd18-4d6e-a7a8-ad80063d9105': 'Fashion and Apparel Merchandising',
	'f4c586f5-e49b-4aad-91b9-a4940a9700f3': 'Film and Video Studies',
	'1fcf52df-7b56-4855-966d-a2e90f834651': 'Finance',
	'5434f2fa-1ae2-477c-ab5a-d7e8e5cab268': 'Financial Planning',
	'957a38cc-4ed7-4648-90af-9ec7bcbf7195': 'Fine and Studio Arts Management',
	'be9b4f38-a975-40a4-9270-4c5f9296dd11': 'Fine Arts',
	'd7154d5b-47a0-4b42-bf4b-b876a59df8ee': 'Fire Protection and Prevention',
	'8fd20c39-0cf2-41a6-b2c1-1b51749adb2c': 'Fire Science and Fire Fighting',
	'6c881639-fa61-4a9a-bfe0-f361cb406831': 'Food Science',
	'd17aadb5-70bb-4cf6-a656-8aeda2084302':
		'Foods, Nutrition, and Wellness Studies',
	'27ae198b-ace1-4da7-a6da-0f9a4447eb6d': 'Foreign Languages and Literatures',
	'2533ee87-7707-4128-b6e8-bc889383c921': 'Foreign Language Teacher  Education',
	'9843f4fd-8aff-4fe6-b566-fd83aed5f33d': 'Forensic Science and Technology',
	'7cdb157b-bfee-45eb-b0ce-efa534f0a742': 'Forestry',
	'31645c34-3f98-4c1c-b0ca-e7916dc80a20': 'French Language and Literature',
	'bc7953b2-db7d-4f8e-9e26-095038d9f26c':
		'Funeral Service and Mortuary Science',
	'77c9f9f2-bd35-4fa3-8d00-228ce2ed3d7e': 'Game Design and Interactive Media',
	'670f7799-067f-4eae-bd5d-458820dc7b8e': 'General Construction Trades',
	'9df2f2fa-5cdc-4210-a1d2-0204a18efdce': 'Genetics',
	'8ca0588d-cff8-4186-b3cd-b076b887d1cd': 'Geography',
	'0e55dec3-1f54-4fdb-a297-5b4db751a7e6': 'Geology and Earth Science',
	'ccab52a5-6468-4cd3-b648-de23eba4a4a4': 'German Language and Literature',
	'257b46f0-5eb4-4743-be2f-93d971bf19a0': 'Global Studies',
	'59be9c73-b164-43c9-a0ac-494cf80c777b': 'Graphic Communications',
	'd7d3101d-1427-43c7-abd4-602da12cee36': 'Graphic Design',
	'396a55cd-226e-4468-a64c-edaab3677194': 'Ground Transportation',
	'c113fed4-fbea-44cf-b6e3-c04bf30978e6': 'Health Aides and Attendants',
	'40cde177-85da-4cb7-b280-30a52f894314': 'Healthcare Management',
	'f83341ba-e8f4-4cc6-ac2f-0dd997008a6d': 'Health Professions',
	'1e656d5d-cb0b-4bdb-b3d7-75deab58904c': 'Health Service Preparatory Studies',
	'e3516aa4-b08b-4b66-b17d-40e8f47f287b': 'Health Teacher Education',
	'3803c48e-ce9d-4bf0-8737-3e3dce78f831': 'Health Unit Coordinator and Manager',
	'b8a839f5-e31f-4704-ae87-4d2535bd9fdf':
		'Heavy Equipment Maintenance Technician',
	'2755f099-9a2b-4791-ae9d-290c690b7bb2': 'High School Education',
	'8daa20bc-127d-4cc8-abf1-9d65f2237d6e': 'Hispanic American Studies',
	'03ad4841-eab1-458f-8aae-097873e4d662':
		'Historic Preservation and Conservation',
	'5cffac6a-efe3-47a3-86bb-4388e403f060': 'History',
	'eaccf929-45b9-4f72-8b5a-1a6b94bb6172': 'History Teacher Education',
	'ef1f870d-d714-4a90-b255-2277e8ecad25':
		'Homeland Security and Disaster Management',
	'549e7f76-57de-4356-9165-909b2a04521c': 'Horticulture',
	'c506da71-338d-415d-9d55-7a15bc61339d': 'Hospitality and Tourism Management',
	'46febc0a-cabc-40d7-9728-590ed4aadb10': 'Hospital Management',
	'b8b13535-fdde-4190-8630-547ccd7be6ed': 'Human Computer Interaction',
	'3249802a-a991-4cb6-964e-6c228229026b': 'Human Development',
	'c50957dd-4e37-4353-91ee-51ead3d57a50': 'Human Resources',
	'ca59cc16-8eae-46f0-a4f5-c78bcdacfd57': 'Human Services',
	'6ef5bac7-eb1e-4fdd-a10a-63b308b1a74a':
		'HVAC and Refrigeration Engineering Technician',
	'46648bb7-b088-4578-8257-5fd565bb14c2': 'Illustration',
	'172176ff-1ec6-4ae2-934b-fa7193e7d3da':
		'Industrial and Organizational Psychology',
	'5fd8eed2-936a-4e1b-8777-d8d9aa2f3f2c': 'Industrial and Product Design',
	'c606b57d-5e58-444d-8743-e5793a6e2e7c': 'Industrial Electronics Technician',
	'54bc6296-e68e-4934-80b7-5d968f2d0f15': 'Industrial Engineering',
	'04930486-0e23-48d0-acf0-b31693def3c9': 'Information Science',
	'ceb11576-acf2-4cb8-974e-928298068dfd': 'Information Technology',
	'62c25e0d-3e02-49a2-a17a-21d39e7f8722': 'Instrumentation Technician',
	'89a662d4-f9ef-42ee-acac-ed3ab6247a3f': 'Insurance',
	'13a78eb6-9a54-4f50-b552-318262b5ceeb': 'Intelligence',
	'8afe3eae-6858-4813-99c1-56695a8c98fc': 'Interdisciplinary Studies',
	'e555f8d8-9b27-4bbb-a8f2-8a1348ad6bab': 'Interior Architecture',
	'1ad88883-86c5-4a2e-b960-73554dc27d1b': 'Interior Design',
	'a07783a7-2e0a-492a-bb5e-e03a22c7495a': 'International Business',
	'39cf86a3-a8c5-4c20-a334-0b5956d33679': 'International Relations',
	'0de07b55-05fa-4111-8c11-c625eacb7354': 'International Studies',
	'0dcd12c3-61a8-49f6-a179-f013d046a4ac': 'Italian Language and Literature',
	'331d86dd-178b-449a-9ee0-387494873f7e': 'Japanese Language and Literature',
	'c0a7feb6-7251-4856-a10d-394257a6f4ce': 'Journalism',
	'c81e5e57-66b5-48d6-817e-ad63998e4954':
		'Kindergarten and Preschool Education',
	'db3d55d2-a174-41cb-a433-8eeb25588def': 'Kinesiology and Exercise Science',
	'14f1182d-03ea-4015-982d-6ac7bb6a468a': 'Lab Technician',
	'c321d257-749a-4378-b7e4-3d4438b8a281': 'Landscape Architecture',
	'8a6c5f51-696c-4cd2-bde6-0577263d03d0': 'Landscaping and Groundskeeping',
	'dc8e22aa-f2df-48c3-adf7-385e6d0fe67e': 'Latin American Studies',
	'9ab1e032-e109-4083-bacf-aaa30d946fd4': 'Latin and Ancient Greek Studies',
	'89210286-1d63-4f52-b6e1-17b9eb6b89d8': 'Legal Administrative Assistant',
	'8781c0c0-a6e1-4cc3-a132-b9475ef50250': 'Legal Studies',
	'b43176d8-c47f-4359-abef-a3710eaade56': 'Liberal Arts and Humanities',
	'1f02e7d3-2136-4420-bf1c-dd7a8863ff0a': 'Library Science',
	'b1324fd4-25de-4cac-bd1f-79c7c25d7963':
		'Licensed Practical Nurse Training (LPN)',
	'2ab789a3-d18b-49e4-8e9e-74dd3ba69a8b':
		'Linguistics, Interpretation, and Translation',
	'2d53d003-b24b-4b7c-a60c-7b2898e48f3e': 'Literature',
	'3fda4ace-27b3-4afe-8284-046908b46d92':
		'Logistics and Supply Chain Management',
	'7f5d1693-0018-42e2-adc9-e8b366c285b2': 'Machine and Metal Working',
	'1dbe3537-174f-4c50-aa79-c666a76334ba': 'Make-Up Artist and Tattooing',
	'f5f07c8c-831f-4c7f-9b38-bac3537328e2':
		'Management Sciences and Information Systems',
	'25f89f16-1089-43da-82a5-cb7f5535fa25': 'Managerial Economics',
	'd03f5139-72d6-407e-9125-4efd4dda83e8': 'Manufacturing Engineering',
	'b2f34530-60a2-4c04-81a9-ba12257ba635':
		'Manufacturing Engineering Technician',
	'bdfadd70-506a-4484-9e50-979f1871fb6e': 'Marine Biology and Oceanography',
	'5155a586-fad4-4467-9fa6-db395d54e55e': 'Marine Science',
	'52d64e20-eb5c-45df-ba17-304447392869': 'Marine Transportation',
	'5b6311c2-64a8-4234-b3ed-0c8c4a41cce3': 'Marketing',
	'6e3de52f-0801-4de6-95da-b63ba78a1354':
		'Marriage and Family Therapy and Counseling',
	'909f8289-03e0-4628-9482-b62e0291638f': 'Massage Therapy and Bodywork',
	'38e67600-1708-41fc-9f1d-a140e8c14331': 'Materials Engineering',
	'235eecf5-67be-4ff3-9f07-63b74f9d7fa1': 'Materials Science',
	'9c19cbb6-2b85-4e72-8cee-0ef0cedccd14': 'Mathematics',
	'3dc67ef0-1972-4385-99fb-a93f06a81071': 'Mathematics Teacher Education',
	'3b43927e-cff8-4cfb-bfbb-9b1a473ba208': 'Mechanical Engineering',
	'4b384fa9-eed8-41f1-baf2-b9f427c51214': 'Mechanical Engineering Technician',
	'f4ea1ee7-e6cd-4565-8044-2f9596a213af': 'Mechanics and Repair',
	'dcf5df9b-9696-4a7d-855e-a2b46492f661': 'Medical Assistant',
	'133cdd67-fb37-4c65-90b5-a9186f454aad':
		'Medical Insurance Billing and Claims',
	'd3d250df-bb92-4863-b8af-d66bcd3a8f9a': 'Medical Insurance Coding',
	'aa56df21-052d-4bf6-808b-b095e197b166': 'Medical Laboratory Technician',
	'd4b816b6-42b0-42f1-ad28-25671d6e3c98': 'Medical Office Assistant',
	'9d7747e1-c527-47da-9fd5-fd8d4007413a': 'Medical Office Management',
	'c0b77605-3d7c-4cf0-829b-2e3419f949a8': 'Medical Records Administration',
	'e09bc641-6ea0-410c-9b39-1a284b5c52ed': 'Medical Records Technician',
	'b4db7719-8e35-4d18-8e48-37980026f016': 'Medical Secretary',
	'c2ce8862-0d98-4145-99d5-26a6ec88b50a': 'Medical Social Work',
	'6ba0327a-ca48-4323-868a-431f3ac74b92': 'Medical Technician',
	'b04cd39f-9115-4489-9cce-3cfee870cd17': 'Mental and Social Health Services',
	'412aa7ce-d37c-4926-bcf1-199681137da0': 'Mental Health Counseling',
	'65fad0bc-ae3d-4617-bb37-547868c360e4': 'Merchandising and Buying Operations',
	'933b5e8a-9435-4bfc-8ff9-6b773c589739': 'Metal and Jewelry Arts',
	'1ba679f1-1fde-4dc5-b8dd-83dd7d0326c7': 'Microbiology',
	'8bda4997-ed8b-495d-8ee0-504d6fc21918': 'Middle School Education',
	'3671f238-1db1-49e5-8ef5-4ee09616f119': 'Midwifery',
	'5fb33231-c28b-4e74-ab5a-7c0989f6fcbc': 'Military Science',
	'6d31d8de-1f62-4f3e-8eea-07bd8e4565fc': 'Military Systems Technology',
	'd4d9e8f3-6bf0-4395-aacb-9e15f627854b': 'Mining and Petroleum Engineering',
	'6f45a618-8fb3-49c4-98ac-0c8536f0dce6': 'Minority and Ethnic Studies',
	'e26b35f1-42f7-42b8-a25b-ab852a644df3': 'Missionary Studies',
	'a1f7391a-b071-4668-b528-7860ab34436b': 'Motorcycle Maintenance and Repair',
	'95e4cba1-aff3-4488-8faf-4e7cd5a03f70': 'Multimedia',
	'68f0dc64-d2dd-458c-967d-abd08c26c935': 'Music',
	'2b649dac-8622-47b9-9221-0a0f4fb39e31': 'Musical Instruments',
	'3c5a8d96-9874-4961-8c3d-ab549fe73ea0': 'Music History and Literature',
	'9d5b34bd-7247-4fe2-94a4-1bb8e582bb47': 'Music Management',
	'093e5f3f-8c87-44ef-8a30-926a02484873': 'Music Performance',
	'a6770d5f-f578-4368-9ec5-56eaed49ae45': 'Music Teacher Education',
	'adee7d7d-cb6b-4f78-91b6-d5d399ff796d': 'Music Technology',
	'56719e21-c348-4d79-9e0b-bfcabd5ae2ee': 'Music Theory and Composition',
	'90ac26c8-9d35-47cf-b944-f252f1a87202': 'Nail Technician',
	'337e70a1-f324-4d06-b558-984e5ac99714':
		'Natural Resources Conservation and Management',
	'acc711f6-080d-4d47-b485-7814050dea9a': 'Natural Sciences',
	'55391138-9a18-4ac0-9da7-131afa382928':
		'Network, Database, and System Administration',
	'6a57fef9-06a8-4117-b62b-8fff3d02bf98': 'Neuroscience and Neurobiology',
	'76356afc-94af-4829-9f01-d34b48d240a7': 'Non-Profit and Public Management',
	'352b3d76-8278-487c-9c05-3038bf3df355': 'North American Studies',
	'21c0ee9c-8545-47c6-880a-6d45ea6d01af': 'Nuclear Engineering',
	'0a918c77-8b97-4154-af60-765afd5d85fe': 'Nuclear Medical Technician',
	'd87701d0-c620-4ea6-b5f4-99ac5a6b594e': 'Nursing',
	'1c8f4117-2670-472c-86f5-cb139dfb8698': 'Nursing Administration',
	'db90820e-2102-4113-ba4e-c21179c45b92': 'Nursing Assistant',
	'882196d1-f0ec-4a33-aa48-f31a84d8e5b1':
		'Nursing Science, Education, and Practice',
	'64835c0e-22d1-404a-a50d-b4c4edde602a':
		'Occupational Safety and Health Technician',
	'786d036c-98af-4729-b6fa-764427974cde': 'Occupational Therapist Assistant',
	'8083c4e0-7e75-4322-b8d2-c4383e04ee4d': 'Occupational Therapy',
	'43dda34d-d754-4b43-8087-f201a60196ff': 'Office Management',
	'0e5c904e-faf2-45a8-bbd0-0b4017fefcf9': 'Operations Management',
	'c74c6685-e4ff-4319-a63b-5b0095f66e58': 'Organizational Behavior Studies',
	'9ff2c0e3-5c38-455f-8f0b-c77af0677c43': 'Osteopathy',
	'02c7db0f-6fdb-4477-91dd-326a153da2e7': 'Painting',
	'51cd18c9-b18e-4e11-8f40-80d52630108b': 'Paralegal',
	'0851dd59-153c-4b42-8bd0-aed40b882161':
		'Parks, Recreation and Leisure Studies',
	'5a2c114d-44d4-499f-b660-6f0343122928':
		'Pastoral Counseling and Specialized Ministries',
	'bfad4f00-3edf-496d-9249-36320bec6fc3':
		'Peace Studies and Conflict Resolution',
	'c92c637c-ea31-4d55-a814-0d76bededbd9': 'Performing Arts',
	'7d3d59db-2994-4be2-9360-0a563e67e4b8': 'Pharmacology and Toxicology',
	'b704637e-b5a9-4f0a-a687-266cf10c0334':
		'Pharmacy and Pharmaceutical Sciences',
	'cc55739e-da8e-4763-b1f7-1bb5cc0fc124': 'Pharmacy Technician',
	'ccb54ea3-3a73-4a14-a49f-1dc6f29b378f': 'Philosophy',
	'2d355ed9-4cd5-441b-9f56-68797011ade1': 'Phlebotomy Technician',
	'143fd637-be94-402b-8cd8-4796198bcbfc': 'Photography',
	'976a7308-6103-41f2-9210-349922d0be74': 'Photojournalism',
	'1d2dd859-ffb1-49d2-b05b-3a93062130f6':
		'Physical Education Teaching and Coaching',
	'b94a9db5-298f-41fa-a155-82b3af3b5a8e': 'Physical Sciences',
	'5949e23f-22a0-4498-8a74-98ff01d38203': 'Physical Therapy',
	'049b572c-1881-49f8-8537-4e63572eaa51': 'Physical Therapy Technician',
	'ba88111b-0fd3-4c1f-85a6-78e2ab42f0cb': 'Physician Assistant',
	'6de4d10c-22ab-45c8-940a-be3c61bb8595': 'Physics',
	'81f31a7e-553b-4540-9309-1bef2f01574e': 'Physiological Psychology',
	'bff2e6af-6f71-4b9e-9737-f0cc8daf965a': 'Physiology and Pathology',
	'16d264d4-408c-4089-a2cf-0bb38583869a': 'Plant Science',
	'7d8d1c13-f415-4ae2-aef8-8905a0ce43c7': 'Playwriting and Screenwriting',
	'4cf314ce-98b1-4ffb-8ba9-ccdcf5bfca8b': 'Plumbing',
	'91347f53-5918-4a60-aa84-27937ecc86ca': 'Podiatry',
	'1b8d9517-5184-4882-b261-1d264be2be3e': 'Police and Criminal Science',
	'71651198-113b-4b10-8ccd-4b0309e72529': 'Political Science and Government',
	'26ac5667-0c86-4038-bee8-982b28dda3b8': 'Precision Production',
	'8a5ba5e7-da12-48cf-a255-13393e6e0422': 'Pre-Law Studies',
	'f5cec120-548e-4bed-b8a8-bb1d1bc69d2a': 'Pre-Medicine Studies',
	'af75f777-c07f-4c33-90c5-e59ffa83244b': 'Printmaking',
	'75827e12-df54-44ff-b9b5-ebf15f5299f0': 'Professional and Technical Writing',
	'e319653d-73a8-4f17-af77-95072d5ebaa4': 'Professional Diver and Instructor',
	'6039cfa8-1d3a-42f4-9741-d5eb6ea36bcd': 'Professional Pilot',
	'5c9eebb8-e0c2-4505-a7b6-11d08118f9c8': 'Property Management',
	'c8b4a2e2-0b47-4a62-896e-95aec08632d6':
		'Psychiatric and Mental Health Services',
	'3d3bcf25-dab8-470e-b545-c75223088b5b': 'Psychology',
	'ca361223-d30d-417a-8073-1f9438ab6cea': 'Public Administration',
	'3c626ab7-9aad-4bb3-829f-9bd440f7200f': 'Public Health',
	'd9a88163-873c-49e5-8396-558f8cb02c31': 'Public Health Education',
	'a99e4cbe-0762-462e-85bc-726d17240daa': 'Public Policy Analysis',
	'c0f0a3cc-88c2-4526-b71f-07ea13afe815': 'Public Relations',
	'5b312d6d-ec4e-48c2-942c-85d29f2cde14': 'Quality Control Technician',
	'b3f83132-8f7b-4b7d-b600-e734690d1882': 'Radiation Therapy',
	'23a0886b-cfa2-4f80-b973-8466f1612abb': 'Radio and Television',
	'304620af-9534-402f-94d7-c68a205a7b7b':
		'Radio and Television Broadcasting Technician',
	'69384ab2-04ff-46fc-8004-af2cafd2acb7': 'Radiologic Technician',
	'b1059fdf-4df4-4402-ba2a-079ba0886e0f': 'Real Estate',
	'9051ddbe-0f9e-44b1-9236-e9caa89460c8': 'Recording Arts Technician',
	'331e2805-e03d-4e15-8054-fff7dc9cbf46': 'Rehabilitation and Therapy',
	'50d32b94-1643-4928-9ff6-892581e92cd2': 'Religious Education',
	'54823891-ccc0-48b8-93f9-eee6863a3724': 'Religious Studies',
	'08e47a24-be77-4a4f-bce1-c100285c78cc': 'Religious Vocations',
	'7b6553ed-f40e-4f5e-ab59-fb554e0996be':
		'Research and Experimental Psychology',
	'9a814ed6-d390-4e7b-b8c5-8ebe3d7ad07f': 'Respiratory Care Therapy',
	'1ed7b196-418f-4af7-b1cc-42e4e89e5478':
		'Restaurant and Food Services Management',
	'64375beb-e029-4c23-8767-72dd06ba357e': 'Retail Management',
	'027f1d52-061e-4811-b999-a595c0e7d00e': 'Rhetoric and Composition',
	'82a447ef-9a7c-4be6-9ec4-3d184a76da06': 'Robotics and Automation Engineering',
	'55c395f8-dc61-4bf0-b356-1265210bbdec':
		'Robotics and Automation Engineering Technician',
	'c8c494e9-d6f9-4f24-8424-7cf6d6655e69':
		'Russian and Eastern European Languages and Literature',
	'8c7a96c9-10ba-47c7-b477-104035ad1315': 'Sales',
	'b4836372-181d-47c1-ae07-d415a7d5df6e':
		'School Counseling and Guidance Services',
	'55ba66b1-e47b-44c1-adc5-341a2f02c656': 'School Psychology',
	'8241aff3-96d9-4c39-ad0a-ac0cf20bae79': 'Science Teacher Education',
	'5ca50084-e4ec-4e7c-998c-ff298f11c255': 'Sculpture',
	'4293ee76-3b4f-4af9-ba30-575df068f489': 'Security Science and Technology',
	'f882bbba-c84b-43c4-ae86-e88444cf8d56': 'Security Services',
	'44adeafe-9b3d-4cc0-8170-12f6ada6d0e3': 'Sign Language',
	'6cfb2b77-e587-4f96-a42e-100e52124406': 'Small Business Management',
	'defbcebc-30dc-4ef3-930f-9f197337b6cb': 'Social Psychology',
	'515139c7-cf1a-458e-8e39-54758e8259ad': 'Social Science Research Methods',
	'8ed9c872-b34f-4ce1-aef6-5fc5fee9a5ad': 'Social Sciences',
	'0e4b19bd-e783-433b-a388-0499f8183087': 'Social Studies Teacher Education',
	'b0689bc4-1d8f-4864-b14a-8c1fdb963ad0': 'Social Work and Youth Services',
	'8cbd0064-5587-45da-bf89-1c81f999623f': 'Sociology',
	'b9270038-779e-48e3-87c7-39b0291df3c4':
		'Sonographer and Ultrasound Technician',
	'4b6b8bb1-1e69-478a-8d65-a00dc9db4ef2': 'Spanish Language and Literature',
	'88f2e9d8-977a-44b4-9c84-6f9e386f84a9': 'Special Education and Teaching',
	'7696fe50-8cde-49fd-845e-8891ff8655e1': 'Speech Language Pathology',
	'ece4e0de-e7ba-4494-a13b-56dcaca60c6e': 'Sport and Fitness Management',
	'f9ede9bb-5d5f-4b15-9cb2-5165afdcf8b5': 'Sports Communication',
	'8e4153e7-b383-4f11-89b8-8cd945f323e7': 'Statistics',
	'bd37536d-eef8-4f63-bdbf-7852ba71cf32': 'Studio Arts',
	'3ab49a44-8e46-4687-9085-cc03c7afe909':
		'Substance Abuse and Addiction Counseling',
	'9be9f170-9c17-4351-8fe8-8ef5c3b63958': 'Surgical Technologist',
	'449c1b11-82eb-4840-8497-d448122333cf': 'Surveying Technician',
	'34e9003f-3e58-4627-81b6-3cad6a80e84c': 'Sustainability Studies',
	'7717dae9-5ed4-4654-9538-66b731d9e599': 'Systems Engineering',
	'046e0c1b-1682-409f-b7e5-271dac70759d': 'Systems Science and Theory',
	'56d29372-948d-4cac-b50d-1c605bd07eaa': 'Talmudic and Rabbinical Studies',
	'f193809c-49a2-4aae-a129-6f00542a93fc': 'Taxation',
	'd71549ae-adf5-4306-958f-ecb5e8c0b4d9': 'Taxidermy',
	'1be795d3-6170-472b-a6c1-da3f67f8e101': 'Teaching Assistant',
	'8c7d8a6f-43f3-4290-8ce9-54de32eebae8':
		'Teaching English as a Second Language',
	'f5fd680b-679a-4df5-9dbb-a0c43b1bba58': 'Theatre Design',
	'34c6f70b-8a29-4c4d-a45b-92e3bd5ec1af': 'Theological and Ministerial Studies',
	'3c2fb035-6ea1-49dc-825c-673c9856add2':
		'Truck,  Bus, and Commercial Vehicle Operation',
	'4e1b9a64-a825-4aae-a580-0a8b9f2efc3d':
		'Urban, Community and Regional Planning',
	'02d0c0e9-50b2-4e63-80c5-d4ff4ea4c9bc': 'Urban Studies and Affairs',
	'e9b55717-da8e-40cd-9953-c7f2fdccd259': 'Veterinary Sciences',
	'9f5509c7-a58f-47d2-921e-cae01bbeaa37': 'Veterinary Technician and Assistant',
	'a2a135f7-6192-4371-9ef0-9f0d20b67aa8': 'Visual and Performing Arts',
	'a734c5ec-703d-46d5-b573-9541976efb97': 'Voice and Opera',
	'fbde61eb-6754-490d-86a4-0fc0ade6a58f': 'Web Page and Digital Design',
	'8384eec6-fc60-4e4f-b968-d2a664b85a7f': 'Welding',
	'd9269721-40a3-40c8-8de1-88ee94369c71': 'Welding Engineering Technician',
	'581e9480-d764-4fa2-acfc-46948aec3d0c': 'Wildlife and Fisheries Management',
	'66b793c5-6de3-4b70-95c7-5db74d886c11': "Women's Studies",
	'8cde91b2-c1a3-465a-bb7f-f9c642aa25c0': 'Woodworking',
	'4d8ad317-d797-4236-bc00-deb9490b7eb2': 'Yoga and Movement Therapy',
	'935efc12-cb16-4532-928b-1a7262624737': 'Zoology and Entomology',
};
